var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('LayoutHeader'),_c('LayoutContent'),_c('LayoutFooter'),_c('LayoutWarningLGPD'),_c('BaseSpinner'),_c('LayoutNotification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }